function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDividerArrow = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Calque 2",
  viewBox: "0 0 24.8 13.54",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M1.28 1.28 12.4 12.26 23.51 1.28",
  style: {
    fill: "none",
    stroke: "#8b0913",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2.57px"
  }
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDividerArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/divider-arrow.d8c0bb200af525dca99d78d9faa33161.svg";